/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import AnalyticsService from 'cio/services/analytics';
import { inject as service } from '@ember/service';
import { IntegrationMethod, IntegrationStatus } from 'cio/models/setup-guide';
import CustomForm from 'cio/models/custom-form';
import FacebookLeadAdsForm from 'cio/models/facebook-lead-ads-form';
import CustomFormsService from 'cio/services/custom-forms';
import { FormIntegrationDetailPanes } from 'cio/components/forms/custom/integration-details';

interface FormsSetupFormsArgs {
  setupGuideOnSelect?: (method: IntegrationMethod, connectedAt: number) => void;
  setupGuideStatus?: IntegrationStatus;
  onConnectForm?: (form: CustomForm | FacebookLeadAdsForm) => unknown;
  source: string;
  list?: boolean;
  isDuplicatingForm?: boolean;
}

export default class FormsSetupForms extends Component<FormsSetupFormsArgs> {
  @tracked showFormProvidersModal = false;
  @service analytics!: AnalyticsService;
  @service customForms!: CustomFormsService;
  @tracked activeCustomForm: FormIntegrationDetailPanes | null = null;
  readonly panes = FormIntegrationDetailPanes;

  @action
  toggleSuggestedFormProvidersModal(): void {
    this.showFormProvidersModal = !this.showFormProvidersModal;
  }

  @action
  toggleCustomFormDataModal(pane: FormIntegrationDetailPanes | null): void {
    this.activeCustomForm = pane;
  }
}
